import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProfileDropdown from 'components/navbar/authenticated/ProfileDropdown';
import { useAppContext } from 'contexts/AppContext';
import React from 'react';
import { Nav, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { appPaths } from 'config';

const TopNavRightSideNavItem = () => {
  const { isDark, isRTL, setConfig } = useAppContext();
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <Nav.Item as={'li'}>
        <Button
          variant="primary"
          size="sm"
          as={Link}
          to={appPaths.vms.create}
          className="me-2"
        >
          + Launch a Cloud Desktop
        </Button>
      </Nav.Item>

      {false && (
        <Nav.Item as={'li'}>
          <Nav.Link
            className="px-2 theme-control-toggle"
            onClick={() => setConfig('isDark', !isDark)}
          >
            <OverlayTrigger
              key="left"
              placement={isRTL ? 'bottom' : 'left'}
              overlay={
                <Tooltip id="ThemeColor">
                  {isDark ? 'Switch to light theme' : 'Switch to dark theme'}
                </Tooltip>
              }
            >
              <div className="theme-control-toggle-label">
                <FontAwesomeIcon
                  icon={isDark ? 'sun' : 'moon'}
                  className="fs-0"
                />
              </div>
            </OverlayTrigger>
          </Nav.Link>
        </Nav.Item>
      )}

      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
